// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dbp-","rootMobile":"styles_rootMobile__Xvjr4"};